import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/partner-doctors',
  	  method: 'get',
        params
  	})
  }

  export function inventory(params) {
    return request({
      url: '/partner-doctors/inventory',
      method: 'get',
      params
    })
  }

export function show(id) {
    return request({
      url: `/partner-doctors/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/partner-doctors',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/partner-doctors/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/partner-doctors/${id}`,
      method: 'delete',
    })
  }